interface DownArrowProps {
    light?: boolean;
    dark?: boolean;
}

const DownArrow = ({ light, dark }: DownArrowProps) => {
    switch (true) {
        case light:
            return (
                <div
                    className="down-arrow-white"
                    data-component="DownArrow"
                ></div>
            );
        case dark:
            return (
                <div
                    className="down-arrow-dark"
                    data-component="DownArrow"
                ></div>
            );
        default:
            return (
                <div className="down-arrow" data-component="DownArrow"></div>
            );
    }
};

export default DownArrow;
